import React from 'react';
import cn from 'classnames';

import ProgressBar from '../ProgressBar/ProgressBar';
import styles from './Steps.module.css';

const Step2 = (props) => {
  const { onSave, stepsData } = props;

  const selectMan = () => onSave({ gender: 'man' });
  const selectWoman = () => onSave({ gender: 'woman' });

  return (
    <div className={styles.stepWrapper}>
      <ProgressBar />
      <div className={styles.wrapperPadding}>
        <div className={styles.stepHeader}>
          What is your biological sex?
        </div>
        <div className={styles.genderList}>
          <div 
            className={cn({ [styles.active]: stepsData.gender === 'man'})} 
            onClick={selectMan}
          >
            Male
          </div>
          <div 
            onClick={selectWoman}
            className={cn({ [styles.active]: stepsData.gender === 'woman'})}
          >
            Female
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step2;